






























































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util';
import AbpBase from '../../../lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import vueformmodel from '../../../lib/vueformmodel';
import { FormItem } from 'view-design';
@Component
export default class suppliermanageaddoredit extends vueformmodel {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop() id: number | undefined;
    model: proxy.MerchantDto = new proxy.MerchantDto();
    agents: any[] = [];
    merbindings:any[] = [];
    ctypes: any[] = [];
    xzctypes:any[]= [];
    tabValue="detail";
    xzctypeid=0;
    agentRate: any[] = [];
    allchannels: any[] = [];
    selectchannels: any[] = [];
    modelchannelTypes: any[] = [];
    // warehouings:any[]=[];
    // inputwarehouingname :proxy.WarehousingProductDto = new proxy.WarehousingProductDto();
    //新增时候用
    inputctchannel:proxy.StorageQueryProductChannelDto = new proxy.StorageQueryProductChannelDto();
    //单个查询时候用
    querystoragecchannel:proxy.IStorageQueryProductChannelDto = new proxy.StorageQueryProductChannelDto();
    storagectypechanels = [];
    allAgentRate = '';
    b_disabled = false;
    s_checklist = [];//已选择
    m_val = ''
    m_check = false;
    sotragecchannellist = {};
    addWarehousingshow = false;
    addctchannelshow = false;
    ctchannelids :any[]=[];
    columns4 = [
        {
            type: 'selection',
            width: 60,
            align: 'center'
        },
        {
            title: '名称',
            slot: 'name'
        },
        {
            title: '费率',
            slot: 'crate',
            width: 100
        },
        {
            title: '权重',
            slot: 'weight',
            width: 100
        }
    ]
    get prox() {
        return new proxy.MerchantServiceProxy();
    }
    agentIsTableLoading = false
    agentcolumns = [
        {
            type: "selection",
            width: 60,
            align: "center",
            fixed: "left",
        },
        {
            title: '通道',
            key: 'name'
        },
        {
            title: '代理费率(%)',
            slot: 'agentRate'
        },

        {
            title: '状态',
            slot: 'status'
        }
    ]
    yueRecordPage = {
        pageSize: 20,
        pageNumber: 1,
        totalPages: 1,
        totalItems: 1,
        sorting: undefined,
        pagesizeopts: [10, 20, 30],
        isTableLoading: false,
        dataList: [],
        totalAmount: 0,
        input: new proxy.MerchantBalanceLogPageInputDto(),
        columns: [
            {
                type: "index",
                width: 60,
                align: "center",
            },
            {
                title: '类型',
                key: 'balanceTypeName'
            },
            {
                title: "变动前",
                key: "balance",
            },
            {
                title: "变动",
                key: "money",
            },
            {
                title: "变动后",
                key: "afterBalance",
            },
            {
                title: "变动说明",
                key: "comment",
            },
            {
                title: "日期",
                slot: "creationTime",
            },
        ],
    };
    yuetzPage = {
        pageSize: 20,
        pageNumber: 1,
        totalPages: 1,
        totalItems: 1,
        sorting: undefined,
        pagesizeopts: [10, 20, 30],
        isTableLoading: false,
        dataList: [],
        totalAmount: 0,
        input: new proxy.MerchantBalanceAdjustOrderPageInputDto(),
        columns: [
            {
                type: "index",
                width: 60,
                align: "center",
            },
            {
                title: '调整单号',
                key: 'orderNo'
            },
            {
                title: "调整金额",
                key: "money",
            },
            {
                title: "调整原因",
                key: "comment",
            },
            {
                title: "日期",
                slot: "creationTime",
            },
        ],
    };
    yufutzPage = {
        pageSize: 20,
        pageNumber: 1,
        totalPages: 1,
        totalItems: 1,
        sorting: undefined,
        pagesizeopts: [10, 20, 30],
        isTableLoading: false,
        dataList: [],
        totalAmount: 0,
        input: new proxy.AdvanceMoneyAdjustOrderPageInputDto(),
        columns: [
            {
                type: "index",
                width: 60,
                align: "center",
            },
            {
                title: '调整单号',
                key: 'orderNo'
            },
            {
                title: "调整金额",
                key: "money",
            },
            {
                title: "调整原因",
                key: "comment",
            },
            {
                title: "日期",
                slot: "creationTime",
            },
        ],
    };
    tabClick(name)
    {      
        if(name == "balancelogs"){
            this.yueRecordPageNumberChange(1);
        }
        if(this.tabValue == "balanceadjustorders")
        {
            this.yuetzPageNumberChange(1);
        }
        if(this.tabValue == "advanceadjustorders"){
            this.yufutzPageNumberChange(1);
        }
    }
    // addWarehousing()
    // {
    //     this.addWarehousingshow = true;
    // }
    addctchannel(){
        this.addctchannelshow = true;
    }
    channeltypeandrate=
    {
        id:undefined,
        rate:undefined
    }
    usestroagectypechannel(e){
        this.b_disabled = true;
        new proxy.StorageQueryProductChannelServiceProxy().queryModel(e).then(x=>{
            this.querystoragecchannel = x;
            this.querystoragecchannel.storageProducts.map(y=>{
             this.ctypes.filter(x=>x.id == y.channelTypeId).map(c=>{
                c.check = true;
                c.rate = y.rate;
             })
             //储备的通道
            var cbchanles = this.querystoragecchannel.storageProductChannels.filter(ss=>ss.channelTypeId == y.channelTypeId);
            // .map(cb=>{
            //产品底下的通道
            this.selectchannels.filter(x=>x.channelTypeId == y.channelTypeId).map(v=>{
               var iscb = cbchanles.findIndex(f=>f.channelId == v.channelId);
               if(iscb != -1){
                v._checked = true;
                v.weight = cbchanles[iscb].weight;
               }else{
                v._checked = false;
                v.weight = 1;
               }    
        });
        })
        this.b_disabled = false;
    });  
         
        
    }
    // usewarehousing(e){
    //     new proxy.WarehousingProductServiceProxy().queryModel(e).then(x=>{
    //         var ss = JSON.parse(x.params);
    //         this.b_disabled = true;
    //         this.ctypes.map(s=>{
    //                 s.check = false;
    //                 s.rate = 0;
    //                ss.filter(x=>x.id == s.id).map(x=>{
    //                 s.check = true;
    //                 s.rate = x.rate;
    //                })
    //          })
    //         this.b_disabled = false;
    //         // this.$forceUpdate()
    //         this.checkchange();
    //     })
    // }
    // savewarehousing()
    // {
    //     let channeltypewarehouings= [];
    //      this.ctypes.filter(x => x.check).map(x => {
    //         this.channeltypeandrate.id = x.id;
    //         this.channeltypeandrate.rate = x.rate;
    //         channeltypewarehouings.push(JSON.parse(JSON.stringify(this.channeltypeandrate)));
            
    //     })
    //      this.inputwarehouingname.params =JSON.stringify(channeltypewarehouings);
        
    //      if(this.inputwarehouingname.params!="" && this.inputwarehouingname.warehousingProductName!="" && this.inputwarehouingname.warehousingProductName != undefined){
    //         this.prox.createWarehousingProduct(this.inputwarehouingname).then(() => 
    //         {
    //             this.$Notice.success({ title: "保存成功" });
    //             this.inputwarehouingname.warehousingProductName=undefined;
    //             new proxy.WarehousingProductServiceProxy().queryAllList().then(x=>{
    //                     this.warehouings = x;
    //                 });
    //         });
    //      }else{
    //         this.$Notice.error({ title: "产品必须勾选或存储名称不能为空" });
    //         this.inputwarehouingname.warehousingProductName=undefined;
    //      }
    //     //  console.log(this.inputwarehouingname);
    //     // this.inputwarehouingname.params = JSON.parse(JSON.stringify(this.channeltypewarehouings));
    //     // console.log(this.channeltypewarehouings);
    // }
    savectchannels()
    {
        let ctchannels=[];
        let ct_ctypes =[];
        this.ctchannelids.map(ct=>{
           this.selectchannels.filter(x=>x.channelTypeId == ct && x._checked).map(x=>{
            let m = new proxy.StorageProductChannelDto();
            m.channelId = x.channelId;
            m.channelTypeId = x.channelTypeId;
            m.weight = x.weight;
            ctchannels.push(m);
           })
           this.ctypes.filter(x=>x.check && x.id == ct).map(y=>{
            let cp = new proxy.StorageProductDto();
            cp.channelTypeId = y.id;
            cp.rate = y.rate;
            ct_ctypes.push(cp);
           });
        })
        
        this.inputctchannel.storageProductChannels = ctchannels;
        this.inputctchannel.storageProducts = ct_ctypes;
        new proxy.StorageQueryProductChannelServiceProxy().createOrUpdate(this.inputctchannel).then(x => {
            this.addctchannelshow = false;
            this.inputctchannel.name = "";
            this.ctchannelids = [];
            this.$Notice.success({ title: '保存成功' });
            new proxy.StorageQueryProductChannelServiceProxy().queryAllList().then(x=>{
                        this.storagectypechanels = x;
                    })
        })
    }
    bindtype(e) {
        if (e == 0) {
            this.m_checkchange(true);
        } else {
            this.selectchannels.map(x => {
                if (x.channelTypeId == e) {
                    x._checked = true;
                }                                                                                                                                                                                                                                                                                                                                                                                                                                                   
            })
        }
    }
    unbindchannels()
    {
        if(this.m_val !="")
        {
            this.selectchannels.map(x=>{
                if(x.name.indexOf(this.m_val)!=-1){
                        if(x._checked == true){
                        x._checked =false;
                    }
                }
            })
        }else
        {
            this.$Notice.error({ title: "通道名称搜索不能为空" });
        }
    }
    untieNegativeProfit(){
        // console.log(this.xzctypes)
        // console.log(this.agentRate)
        // console.log(this.selectchannels)
        if(this.xzctypeid == 0){
            this.ctypes.map(x=>{
                this.agentRate.map(c=>{
                    if(x.id == c.id){
                        var meragentrate = x.rate-c.rate;
                        this.selectchannels.map(b=>{
                            if(x.check == true && x.id == b.channelTypeId ){
                                if(! (meragentrate - b.crate >= 0)){
                                    b._checked = false
                                }
                            }
                        })
                    }
                })
            })
        }else{
           var ctyid = this.ctypes.filter(x=>x.id == this.xzctypeid);
           if(ctyid.length > 0){
            this.agentRate.map(c=>{
                    if(ctyid[0].id == c.id){
                        var meragentrate = ctyid[0].rate-c.rate;
                        this.selectchannels.map(b=>{
                            if(ctyid[0].check == true && ctyid[0].id == b.channelTypeId ){
                                if(! (meragentrate - b.crate >= 0)){
                                    b._checked = false
                                }
                            }
                        })
                    }
            })
           }
        }
        
        this.$forceUpdate()
    }
    pagesizeChange(data, page, t) {
        data.pageSize = page;
        switch (t) {
            case 1:
                    this.yueRecordPageNumberChange(data.pageNumber);
                break;
            case 2:
                    this.yuetzPageNumberChange(data.pageNumber);
                break;
            case 3:
                    this.yufutzPageNumberChange(data.pageNumber);
                break;
        }
    }

    yueRecordPageNumberChange(page: number) {
        this.yueRecordPage.isTableLoading = true;
        this.yueRecordPage.input.maxResultCount = this.yueRecordPage.pageSize;
        this.yueRecordPage.input.skipCount = (page - 1) * this.yueRecordPage.pageSize;
        this.yueRecordPage.input.merchantId = this.id || 0;
        new proxy.MerchantBalanceLogServiceProxy().queryModelList(this.yueRecordPage.input).then((x) => {
            this.yueRecordPage.isTableLoading = false;
            this.yueRecordPage.dataList = x.items;
            this.yueRecordPage.totalItems = x.totalCount;
            this.yueRecordPage.totalPages = Math.ceil(
                x.totalCount / this.yueRecordPage.pageSize
            );
        });
    }
    yuetzPageNumberChange(page: number) {
        this.yuetzPage.isTableLoading = true;
        this.yuetzPage.input.maxResultCount = this.yuetzPage.pageSize;
        this.yuetzPage.input.skipCount = (page - 1) * this.yuetzPage.pageSize;
        this.yuetzPage.input.merchantId = this.id || 0;
        new proxy.MerchantBalanceAdjustOrderServiceProxy().queryModelList(this.yuetzPage.input).then((x) => {
            this.yuetzPage.isTableLoading = false;
            this.yuetzPage.dataList = x.items;
            this.yuetzPage.totalItems = x.totalCount;
            this.yuetzPage.totalPages = Math.ceil(
                x.totalCount / this.yuetzPage.pageSize
            );
        });
    }
    yufutzPageNumberChange(page: number) {
        this.yufutzPage.isTableLoading = true;
        this.yufutzPage.input.maxResultCount = this.yufutzPage.pageSize;
        this.yufutzPage.input.skipCount = (page - 1) * this.yufutzPage.pageSize;
        this.yufutzPage.input.merchantId = this.id || 0;
        new proxy.AdvanceMoneyAdjustOrderServiceProxy().queryModelList(this.yufutzPage.input).then((x) => {
            this.yufutzPage.isTableLoading = false;
            this.yufutzPage.dataList = x.items;
            this.yufutzPage.totalItems = x.totalCount;
            this.yufutzPage.totalPages = Math.ceil(
                x.totalCount / this.yufutzPage.pageSize
            );
        });
    }

    allAgentRateSynchronous() {
        this.agentRate.map(x => {
            x.rate = this.allAgentRate;
        })
    }

    rowClassName(row, index) {
        if (row._checked == true) {
            return 'demo-table-info-row';
        }
        return '';
    }
    agentIdchange(e) {
        if (e) {
            this.model.agentName = this.agents.find(x => x.id == e).name;
        } else {
            this.model.agentName = '';
        }
    }
    bindingChannelType()
    {
        this.ctypes.map(x=>{
            x.check = true
        })
        this.$forceUpdate()
        this.checkchange()
    }
    rowchange(row, index) {
        this.selectchannels[index] = row;
    }

    agentRateChange(row, index) {
        this.allchannels[index].agentRate = row.agentRate;
    }

    // selectchannelschange(checklist) {
        // this.s_checklist = checklist;
        // this.selectchannels.map(x => {
        //     if (checklist.findIndex(p => p.channelId == x.channelId && p.channelTypeId==x.channelTypeId) != -1) {
        //         x._checked = true;
        //     } else {
        //         x._checked = false;
        //     }
        // })
    // }
    checkchange() {
        let arr2: any[] = []
        this.ctypes.map(x => {
            if (x.check) {
                let arr3 = [];
                x.channelTypeChannels.map(cn => {
                    if (arr3.findIndex(p => p.channelId == cn.channelId && p.channelTypeId == x.id) == -1) {
                        let c = this.allchannels.find(p => p.id == cn.channelId);
                        if (c) {
                            let m = {
                                channelId: c.id,
                                id: 0,
                                _disabled: false,
                                _checked: false,
                                weight: 1,
                                name: c.name,
                                status: c.status,
                                typename: x.name,
                                typecode: x.code,
                                channelTypeId: x.id,
                                crate: c.rate
                            }
                            let sc = this.selectchannels.find(x => x.channelId == m.channelId && x.channelTypeId == m.channelTypeId);
                            if (sc) {
                                
                                m._checked = sc._checked;
                            }
                            // if (c.status == 1) {
                            //     m._disabled = true;
                            // }
                            if (this.model.merchantChannels && this.model.merchantChannels.length) {
                                let index = this.model.merchantChannels.findIndex(p => p.channelId == c.id && p.channelTypeId == x.id);
                                if (index != -1) {
                                    m._checked = true;
                                    if (this.model.merchantChannels[index].weight > 0) {
                                        m.weight = this.model.merchantChannels[index].weight;
                                    }

                                }
                            }
                            // if(this.querystoragecchannel.storageProductChannels && this.querystoragecchannel.storageProductChannels.length)
                            // {
                            //     let index = this.querystoragecchannel.storageProductChannels.findIndex(s=>s.channelId == c.id && s.channelTypeId == x.id);
                            //     if(index != -1){
                            //         m._checked = true;
                            //         if(this.querystoragecchannel.storageProductChannels[index].weight > 0){
                            //             m.weight = this.querystoragecchannel.storageProductChannels[index].weight;
                            //         }
                            //     }
                            // }
                            arr3.push(m);

                        }
                    }

                })
                arr3 = arr3.sort((a, b) => a.crate - b.crate);
                arr2.push(...arr3);
            }
        })
        this.selectchannels = arr2;
    }

    channelChange(selection) {
        this.allchannels.map(c => {
            if (selection.findIndex(x => x.id == c.id) != -1) {
                c._checked = true;
            } else {
                c._checked = false;
            }
        })
    }

    save() {

        this.model.merchantChannels = this.selectchannels.filter(x => x._checked);

        let arr = this.ctypes.filter(x => x.check).map(x => {
            let m = new proxy.MerchantChannelTypeDto();
            m.channelTypeId = x.id;
            m.rate = x.rate;
            return m;
        })
        let arr2 = this.agentRate.map(x => {
            let m = new proxy.MerchantAgentRateDto();
            m.channelTypeId = x.id;
            m.agentRate = x.rate;
            return m
        })
        this.model.merchantChannelTypes = arr;
        this.model.merchantAgentRates = arr2;
        this.model = proxy.MerchantDto.fromJS(this.model);
        (this.$refs.roleForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.prox.createOrUpdate(this.model).then(() => {
                    (this.$refs.roleForm as any).resetFields();
                    this.$Notice.success({ title: '保存成功' });
                    this.$emit('save-success');
                    this.$emit('input', false);
                });
            }
        });
    }
    cancel() {
        (this.$refs.roleForm as any).resetFields();
        this.tabValue = "detail";
        this.$emit('input', false);
    }
    m_checkchange(e) {
        this.selectchannels.map(x => {
            x._checked = e
        })
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.tabValue = "detail"
            this.$emit('input', value);
        } else {
            this.m_val = ''
            this.allAgentRate = '';
            this.b_disabled = true;
            this.m_check = false;
            // let req = new proxy.AgentPageInputDto();
            // req.maxResultCount = 200;
            // req.status = 0;
            this.prox.queryAgentList().then(x => {
                this.agents = x;
            })
            let req1 = new proxy.MerchantAndMerBinDingPageInputDto();
            req1.maxResultCount = 200;
            new proxy.MerchantAndMerBinDingServiceProxy().queryModelList(req1).then(x=>{
                this.merbindings = x.items;
            })
            let req2 = new proxy.ChannelTypePageInputDto();
            req2.maxResultCount = 500;
            req2.sorting = 'code asc, id desc';
            new proxy.ChannelTypeServiceProxy().queryModelList(req2).then(x => {
                 
                this.ctypes = x.items
                this.xzctypeid=0;
                var ss = JSON.stringify(x.items);
                this.xzctypes = JSON.parse(ss);
                this.xzctypes.unshift({id:0,name:'全部',code:'全部产品'})
                this.agentRate = JSON.parse(JSON.stringify(x.items));
                this.agentRate.map(a => { a.rate = 0 })
                this.ctypes.map(x => {
                    x.check = false;
                })

                let req3 = new proxy.ChannelSimpleInputDto();
                this.selectchannels = []
                this.prox.queryModel(this.id).then(x => {
                    this.model = x;
                    if (!this.model.settlementTime) {
                        this.model.settlementTime = '23:59:59';
                    }

                    if (this.model.merchantChannelTypes && this.model.merchantChannelTypes.length) {
                        this.ctypes.map(c => {
                            let i = this.model.merchantChannelTypes.findIndex(p => p.channelTypeId == c.id);
                            if (i != -1) {
                                c.check = true;
                                c.rate = this.model.merchantChannelTypes[i].rate || 0;
                            }
                        })
                    }
                    new proxy.ChannelServiceProxy().queryAllList(req3).then(x => {
                        this.allchannels = x.sort((a, b) => a.rate - b.rate);

                        this.checkchange();

                        if (this.model.merchantAgentRates && this.model.merchantAgentRates.length) {
                            this.agentRate.map(c => {
                                let i = this.model.merchantAgentRates.findIndex(p => p.channelTypeId == c.id);
                                if (i != -1) {
                                    c.rate = this.model.merchantAgentRates[i].agentRate || 0;
                                }
                            })
                        }
                        this.b_disabled = false;
                    })
                    // new proxy.WarehousingProductServiceProxy().queryAllList().then(x=>{
                    //     this.warehouings = x;
                    // });
                    new proxy.StorageQueryProductChannelServiceProxy().queryAllList().then(x=>{
                        this.storagectypechanels = x;
                    })
                    // this.yueRecordPageNumberChange(1);
                    // this.yuetzPageNumberChange(1);
                    // this.yufutzPageNumberChange(1);
                });

            })
        }
    }
    initchanns() {
        let arr2: any[] = []
        this.ctypes.map(x => {
            if (x.check) {
                x.channelTypeChannels.map(cn => {
                    if (arr2.findIndex(p => p.channelId == cn.channelId && p.channelTypeId == x.id) == -1) {
                        let c = this.allchannels.find(p => p.id == cn.channelId);
                        if (c) {
                            let m = {
                                channelId: c.id,
                                id: 0,
                                _disabled: false,
                                _checked: false,
                                weight: 1,
                                name: c.name,
                                status: c.status,
                                typename: x.name,
                                typecode: x.code,
                                channelTypeId: x.id,
                                crate: c.rate
                            }
                            if (this.model.merchantChannels && this.model.merchantChannels.length) {
                                let index = this.model.merchantChannels.findIndex(p => p.channelId == c.id && p.channelTypeId == x.id);
                                if (index != -1) {
                                    m._checked = true;
                                    if (this.model.merchantChannels[index].weight > 0) {
                                        m.weight = this.model.merchantChannels[index].weight;
                                    }

                                }
                            }
                            arr2.push(m);

                        }
                    }

                })
            }
        })

        this.selectchannels = arr2;

    }
    roleRule = {

    };
}
